'use client';

import React, { useCallback, useState, useMemo } from 'react';
import { Button } from 'reactstrap';

import { useAppSelector } from 'src/hooks/redux-hooks';
import { copyToClipboard } from 'src/helpers/utils';

import { CopySvg } from 'src/assets/images/job-details-slide-out/job-details-slide-out';
import { Tooltip } from 'react-tooltip';

const CopyButton: React.FC = () => {
  const [copied, setCopied] = useState(false);
  const job = useAppSelector((state) => state?.jobDetails?.data);
  const type = useAppSelector((state) => state?.jobDetails?.slideOut?.type);

  const renderCopiedText = useMemo(
    () => {
      if (type === 'jobDetails') {
        return copied ? 'Job URL Copied!' : 'Copy Job URL';
      }
      if (type === 'serviceRequestDetails') {
        return copied ? 'MR URL Copied!' : 'Copy MR URL';
      }
      return '';
    },
    [copied, type],
  );

  const handleCopy = useCallback(() => {
    const paramType = (type === 'jobDetails') ? 'jobId' : 'mr';
    const base = `${window?.location?.origin}${
      window?.location?.pathname
    }`;
    const val = (type === 'jobDetails')
      ? job?.job_no
      : job?.service_request_no;
    const url = `${base}?${paramType}=${val}`;
    copyToClipboard(`${url || ''}`);
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 1000);
  }, [job?.job_no, job?.service_request_no, type]);

  return (
    <React.Fragment>
      <Button
        type="button"
        className="copy-btn"
        color="none"
        onClick={handleCopy}
        data-tooltip-id="copy_mr_id"
        data-tooltip-content={renderCopiedText}
      >
        <CopySvg />
      </Button>
      <Tooltip
        id="copy_mr_id"
        className="copy-url-tooltip"
        positionStrategy="fixed"
        border="1px solid #D7E1F4"
        opacity={1}
      />
    </React.Fragment>
  );
};

export default CopyButton;
